import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { ReducedUser, User } from '@/modules/User/interfaces/user'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { Property } from '@/modules/Property/interfaces/property'
import { Insured } from '@/modules/Insured/interfaces/insured'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import { File } from '@/modules/File/interfaces/file'
import { Label } from '@/modules/Label/interfaces/label'
import { Case } from '@/modules/Case/interfaces/case'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { GeneralAgent } from '@/modules/GeneralAgent/interfaces/general-agent'
import { Book } from '@/modules/Book/interfaces/book'

export enum PolicyStatus {
  EFFECTIVE = 'EFFECTIVE',
  EXPIRED = 'EXPIRED',
  ABOUT_TO_EXPIRE = 'ABOUT_TO_EXPIRE',
  NO_ACTIVE = 'NO_ACTIVE',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED'
}

export enum BillingType {
  DIRECT_BILL = 'DIRECT_BILL',
  AGENCY_DIRECT_BILL = 'AGENCY_DIRECT_BILL',
  AGENCY_BILL = 'AGENCY_BILL'
}

export enum DepositoryStatus {
  MOBILE_DEPOSITED = 'MOBILE_DEPOSITED',
  BANK_DEPOSTITED = 'BANK_DEPOSTITED',
  ON_HOLD = 'ON_HOLD'
}

export enum PolicyTypeEnum {
  RENEWAL = 'RENEWAL',
  NEW_BUSINESS = 'NEW_BUSINESS',
  REWRITE = 'REWRITE',
  BOR = 'BOR',
  REMARKET = 'REMARKET',
  ENDORSEMENT = 'ENDORSEMENT',
}

export enum PolicyPremiumPaymentMethod {
  CREDIT_CARD = 'CREDIT_CARD',
  CASH = 'CASH',
  QUICKBOOK = 'QUICKBOOK',
  CLIENT_CHECKS = 'CLIENT_CHECKS',
  ACH = 'ACH',
}

export enum PolicyCommissionPaymentMethod {
  DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
  AGENCY_BILL_OBTAINED = 'AGENCY_BILL_OBTAINED',
  OTHER = 'OTHER',
}

export enum PayerType {
  BILL_MORTGAGE = 'bill-mortgage',
  BILL_INSURED = 'bill-insured',
}

export interface queryFilter {
  policyName?: string | null
  caseId?: number | null,
  quoteId?: number | null,
  contactId?: number | null,
  accountId?: number | null,
  carrierProductId?: number | null,
  isCaseRelated?: boolean | null,
  startDate?: string | null,
}

export interface Policy {
  id: number;
  policyName: string;
  status: PolicyStatus;
  cancelDate: string;
  borDate: string;
  effectiveDate: string;
  expirationDate: string;
  bindDate: string;
  originalInceptionDate: string;
  commissionPaymentEffectiveDate: string;
  commissionPaymentExpirationDate: string;
  brokerFee: string;
  agencyFee: string;
  carrierPolicyFee: string;
  inspectionFee: string;
  taxesFee: string;
  stampingFee: string;
  premium: string;
  policyNumber: string;
  term: number;
  federalEmployerIdNumber: string;
  closed: boolean; //
  nonRenew: boolean; //
  shouldAutoCancel: boolean; //
  shouldAutoBor: boolean; //
  createdAt: string; //
  updatedAt: string; //
  additionalInfoStr: string;
  caseId: number;
  book: Book;
  account: Account;
  primaryContact: Contact;
  source: Producer;
  carrier: Carrier;
  carrierProduct: CarrierProduct;
  insuranceQuote: Quote;
  recordType: RecordType; //
  productCommissionOverride: string;
  totalCommissionReceived: string;
  payerType: PayerType;
  createdBy: ReducedUser; //
  lastModifiedBy: ReducedUser // ;
  attachments: File[]; //
  vehicles: Vehicle[]; //
  insureds: Insured[]; //
  properties: Property[]; //
  acordForms: AcordForm[]; //
  isPremiumPayOff: boolean; //
  isCommissionPayOff: boolean; //
  isPaidToCarrier: boolean; //
  billingType: BillingType;
  payments: PolicyPayment[]; //
  commissions: PolicyCommission[]; //
  installmentPlan: number;
  totalProjectedPremium: number;
  totalProjectedCommission: number;
  totalPremiumReceived: number;
  labels: Label[]; //
  type: PolicyTypeEnum;
  inheritPolicies: {
    fromPolicy: Policy,
    toPolicy: Policy,
  };
  openedCases: Case[];
  writingAgents: User[];
  generalAgent: GeneralAgent;
}

export interface attachmentInfo {
  name: string;
  type: string;
  date: string;
  size?: string;
}

export interface propertyInfo {
  address: string;
  city: string;
  state: string;
  area: string;
}

export interface insuredsInfo {
  name: string
  relation: string
  birth: string
}

export interface paymentInfo {
  number: string
  amount: string
  method: string
  created: string
}

export interface vehicleInfo {
  vehicle: string
  vin: string
  note: string
  isActive: boolean
}
export interface historyInfo {
  date: string
  field: string
  user: string
  originalValue: string
  newValue: string
}

export interface PolicyPayment{
  id: number,
  amount: number,
  receivedDate: string,
  status: DepositoryStatus,
  paymentMethod: PolicyPremiumPaymentMethod,
  notes: string,
  createdAt: string,
  updatedAt: string,
  createdBy: ReducedUser,
  receivedDateValueOf: string
}

export interface PolicyCommission{
  id: number,
  amount: number,
  receivedDate: string,
  status: DepositoryStatus,
  paymentMethod: PolicyCommissionPaymentMethod,
  notes: string,
  createdAt: string,
  updatedAt: string,
  createdBy: ReducedUser,
  receivedDateValueOf: string,
  statementId: number
}
